// removed by extract-text-webpack-plugin
module.exports = {"button":"PasswordChangeForm__button___3ce81"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/passwordChange/PasswordChangeForm.css
// module id = 1211
// module chunks = 0